import React from 'react';
import { i18n } from '../../i18n/translate';
import LoginLink from '../Modals/LoginLink';
import { HeaderMenu } from '../HeaderMenu';
import { Button } from '../Button';

interface Props {
  adminifiDomain: string;
  authCapabilities: object;
  authUrls: object;
  content: object;
  contentLibrarySearch?: string;
  customRight: string;
  helpMessage: string;
  helpMessageEnabled: boolean;
  hideLogin: boolean;
  hideMenu: boolean;
  homeroomDomain: string;
  idProvidersUrl: string;
  isFoundry: boolean;
  renderAsLegacy: boolean;
  isHomeroom: boolean;
  isImpersonating: boolean;
  isMobile: boolean;
  languages: object;
  loginText: string;
  menuData: object;
  onLoginLoad: () => void;
  onStopImpersonation: () => void;
  selectedLanguage: object;
  socialIcon: string;
  user?: {
    guest?: boolean;
    organization_slug?: string;
    rule_sets?: object;
  };
}

const TopRightMenu: React.FC<Props> = ({
  adminifiDomain,
  authCapabilities,
  authUrls,
  content,
  contentLibrarySearch,
  customRight,
  helpMessage,
  helpMessageEnabled,
  hideLogin,
  hideMenu,
  homeroomDomain,
  idProvidersUrl,
  isFoundry,
  isHomeroom,
  isImpersonating,
  isMobile,
  languages,
  loginText,
  menuData,
  onLoginLoad,
  onStopImpersonation,
  selectedLanguage,
  socialIcon,
  renderAsLegacy = true,
  user,
}: Props) => {
  const showLogin = !content && !hideLogin && user?.guest;
  const showMenu = !user?.guest && !!menuData && !hideMenu && !content;

  return (
    <>
      {!!customRight && (
        <ul
          className="nav navbar-top-links navbar-right d-flex align-items-center"
          aria-expanded="false"
          dangerouslySetInnerHTML={{ __html: customRight }}
        ></ul>
      )}
      {contentLibrarySearch && !content && (
        <div className="search-content-link">
          <Button
            href={contentLibrarySearch}
            aria-label={i18n.t('Search')}
            label={i18n.t('Search')}
            className="capitalize with-border"
            data-attribute="content-search-button"
            data-object-id="content-search-btn"
            style="secondary"
            branded={true}
            icon="search"
          />
        </div>
      )}
      {showLogin && (
        <LoginLink
          name={i18n.t('Login')}
          login_text={loginText}
          authCapabilities={authCapabilities}
          idProvidersUrl={idProvidersUrl}
          socialIcon={socialIcon}
          onLoginLoad={onLoginLoad}
          hideLogin={hideLogin}
          /* @ts-ignore */
          authUrls={authUrls}
        />
      )}
      {showMenu && (
        /* @ts-ignore */
        <HeaderMenu
          adminifiDomain={adminifiDomain}
          currentRuleSets={user?.rule_sets ?? []}
          helpMessage={helpMessage}
          helpMessageEnabled={helpMessageEnabled}
          homeroomDomain={homeroomDomain}
          isFoundry={isFoundry}
          isHomeroom={isHomeroom}
          isImpersonating={isImpersonating}
          isMobile={isMobile}
          languages={languages}
          menuData={menuData}
          renderAsLegacy={renderAsLegacy}
          onStopImpersonation={onStopImpersonation}
          organizationSlug={user?.organization_slug}
          selectedLanguage={selectedLanguage}
          user={user}
        />
      )}
    </>
  );
};

TopRightMenu.displayName = 'TopRightMenu';

export default TopRightMenu;
